import { useEffect } from 'react';
import { useNotificationsStore } from '../services/notificationsStore';
import { sendNotification, getNotificationPreference } from '../services/pushNotifications';

/**
 * Hook that sends push notifications when new notifications are added
 */
export const usePushNotifications = () => {
  const { notifications } = useNotificationsStore();

  useEffect(() => {
    if (!getNotificationPreference()) {
      return;
    }

    // Get the most recent unread notification
    const unreadNotifications = notifications.filter((n) => !n.read);
    if (unreadNotifications.length > 0) {
      const lastNotification = unreadNotifications[unreadNotifications.length - 1];
      sendNotification(lastNotification);
    }
  }, [notifications]);
};
